<div class="success-container">
  <div mat-dialog-content>
    <mat-card-title>
      {{ content | translate }}
      <span [innerHTML]="emoji"></span>
    </mat-card-title>
    @if (subtitle) {
      <mat-card-subtitle>
        {{ subtitle | translate }}
      </mat-card-subtitle>
    }
  </div>
  <div mat-dialog-actions class="action-button">
    <button
      type="button"
      mat-raised-button
      color="accent"
      [mat-dialog-close]="true"
      >
      {{ action | translate }}
    </button>
  </div>
</div>
